// import { graphql, useStaticQuery } from 'gatsby'
import { PackageCard as PackageCardLeshenUI } from '@leshen/ui'
import React from 'react'

const PackageCard = ({
  label,
  packageData,
  modal,
  children,
  content,
  mobileCarousel,
  layout,
  image,
  priceOld,
  priceOutro,
  features,
}) => (
  <PackageCardLeshenUI
    label={label}
    packageData={packageData}
    priceOld={priceOld}
    priceOutro={priceOutro}
    features={features}
    modal={modal}
    content={content}
    mobileCarousel={mobileCarousel}
    layout={layout}
    image={image}
  >
    {children}
  </PackageCardLeshenUI>
)
export default PackageCard
